export default {"src":"/uk/_next/static/media/spot-transfer-money.46bbdb89.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};